<template>
  <div>
    <div class="flex-center" :class="`FS${FS}`">
      <div class="P30" ref="myElement">
        <div class="form">
          <div v-for="row in option" :key="row.index" class="form-item-row">
            <slot v-if="row.slot" :data="{form,row}"/>

            <div v-else-if="row.title" class="flex-center" :style="{'height': VW(row.height || 3.5)}" style="width: 100%">
              <h2>{{ form[row.prop] }}{{ row.content }}</h2>
            </div>

            <div
                v-else
                class="row-item"
                v-for="rowItem in row.children"
                :key="rowItem.index"
                :style="{'height': VW(row.height || 2.5),'width': RowItemWidth(row,rowItem)}"
            >
              <div class="row-item-label PL5 border" :style="{'width':VW(rowItem.labelWidth || 8)}">
                {{ rowItem.label }}
              </div>
              <div class="row-item-value PX5" :style="{'width': RowItemValueWidth(row,rowItem)}">
                {{ form[rowItem.prop] }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex-center P10">
        <span :style="{'width':VW(formWidth / footer.length)}" v-for="f in footer" :key="f.index" class="bolder">
          {{ f.label }}{{ form[f.prop] }}
        </span>
        </div>
      </div>
    </div>

    <div class="flex-center" v-if="downloadShow">
      <div class="shadow P15 MT30 flex-center">
        <span class="bolder c-4a4a4a">字体大小：</span>
        <el-input-number v-model="FS" size="small" class="MR50"/>
        <span class="bolder c-4a4a4a">下载预览：</span>
        <el-image :src="url" :preview-src-list="[url]" style="width: 4vw"/>
        <el-button class="ML50" size="small" @click="downloadPNG" type="primary">点击下载(PNG)</el-button>
        <el-button class="ML50" size="small" @click="downloadPDF" type="primary">点击下载(PDF)</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import {type} from "otb-module/src/utils/tool";
import jsPDF from 'jspdf';

export default {
  name: "hFormTable",
  props: {
    form: {
      required: true,
      type: Object
    },
    formWidth: {
      type: Number,
      default: 80
    },
    fontSize: {
      type: Number,
      default: 15
    },
    option: {
      required: true,
      type: Array
    },
    footer: {
      type: Array
    },
    downloadShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    VW() {
      return v => {
        if (type(v) === "Number") return v + "vw";
        return v;
      };
    },
    RowItemWidth() {
      return (row, rowItem) => {
        if (rowItem["proportion"] && rowItem["proportion"].length === 2) {
          return this.VW(this.formWidth / rowItem["proportion"][1] * rowItem["proportion"][0]);
        }
        return this.VW(this.formWidth / row.children.length);
      };
    },
    RowItemValueWidth() {
      return (row, rowItem) => {
        if (rowItem["proportion"] && rowItem["proportion"].length === 2) {
          return this.VW(this.formWidth / rowItem["proportion"][1] * rowItem["proportion"][0] - (rowItem.labelWidth || 8));
        }
        return this.VW(this.formWidth / row.children.length - (rowItem.labelWidth || 8));
      };
    }
  },
  data() {
    return {
      url: undefined,
      FS: 15
    }
  },
  watch: {
    fontSize: {
      handler(newVal) {
        this.FS = newVal;
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.generate();
  },
  methods: {
    async generate() {
      const t = this;
      await html2canvas(this.$refs.myElement).then(function (canvas) {
        t.url = canvas.toDataURL('image/png');
      });
    },
    downloadPNG() {
      const link = document.createElement('a');
      link.href = this.url;
      link.download = 'image.png';
      link.click();
    },
    downloadPDF() {
      html2canvas(this.$refs.myElement).then(function (canvas) {
        const pdf = new jsPDF("landscape");
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = canvas.height * (imgWidth / canvas.width);
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save('exported.pdf');
      });
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px #000000 solid;

.form {
  border-left: $border;
  border-bottom: $border;

  .form-item-row {
    display: flex;
    align-items: center;
    border-top: $border;
    border-right: $border;
  }

  .row-item + .row-item {
    border-left: $border;
  }

  .row-item {
    display: -webkit-box;
    align-items: center;

    .row-item-label {
      border-right: $border;
      height: 100%;
      display: flex;
      align-items: center;
      font-weight: bold;
    }

    .row-item-value {
      display: flex;
      align-items: center;
    }
  }
}
</style>
